import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RequestStatus } from "@app/constants";

import { IDashboardState } from "./types";

const initialState: IDashboardState = {
  dashboard: {},
};

const slice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    dashboard(state, action: PayloadAction) {
      state.dashboard.status = RequestStatus.RUNNING;
    },
    dashboardSuccess(state, action) {
      state.dashboard.status = RequestStatus.SUCCESS;
      state.dashboard.data = action.payload;
    },
    dashboardFailed(state, action: PayloadAction<any>) {
      state.dashboard.status = RequestStatus.ERROR;
      state.dashboard.error = action.payload;
    },
  },
});

export default slice.reducer;
export const { dashboard, dashboardSuccess, dashboardFailed } = slice.actions;
